$shm_hitalama_map_widget_float_table_grid $mol_grid
	scroll_top? 0
	viewport_height 0
	header_height 40
	render_visible_only false
	Table $shm_hitalama_map_widget_float_table_grid_list
		sub <= rows
		scroll_top? <=> scroll_top?
		viewport_height <= viewport_height
		header_height <= header_height
		render_visible_only <= render_visible_only

$shm_hitalama_map_widget_float_table_grid_list $mol_grid_table
	render_visible_only false
	scroll_top? 0
	viewport_height 0
	row_height 40
	header_height 40
	overscan 4
